/**
 * Mistral (Le Chat) journey — protocol `discovery-only` (ADR-0159 §3).
 * See `meta.ts` for the shape.
 */

import { buildDiscoveryOnlyTerminalPhase } from './discovery-only-terminal.js';
import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildMistralJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    buildDiscoveryOnlyTerminalPhase(agent),
  ];
}
